module.exports = __webpack_public_path__ + "img/DocPanDemo.67af0d39.gif";